// extracted by mini-css-extract-plugin
module.exports = {"stocks":"Stocks_stocks__3FCBq"};